<script lang="ts">
  import { t } from "$lib/services/i18n";
  import MessageModal from "./message-modal.svelte";

  export let isOpen: boolean;
  export let message: string;
  export let onCloseCallback: () => void = () => {
    // console.log("empty");
  };
</script>

<MessageModal {isOpen} title={$t("Error")} {message} {onCloseCallback} />
